.sidebar-icon {
  display: block;
}
